import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/admin/enrollment-questionnaire")({
  beforeLoad: () => {
    throw redirect({
      to: "/dashboard/admin/settings",
      search: { section: "therapist-onboarding", tab: "questionnaire" },
    });
  },
});
